import axios from 'axios';
import {
  getUserFromLS,
  setUserToLS
} from '../../../helpers/localstorage-helper';
import { KYC_CONGRATULATIONS } from '../../../routes/routes';
import { changeUserInfo } from '../../../slices/auth-slice';
import { UserInfoType } from '../../../types/loginTypes';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorToast } from '../../../components';

interface AddKycSelfieType {
  formData: FormData;
  history: any;
}

export const addKycSelfie = createAsyncThunk(
  'kyc/addKycSelfie',
  async (
    { formData, history }: AddKycSelfieType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/user/selfie/image`, formData);

      const kycStatus = data.data.kycStatus;

      const currentUser: UserInfoType = getUserFromLS();

      const user = { ...currentUser, kycStatus };

      dispatch(changeUserInfo(user));

      setUserToLS(user);

      history.push(KYC_CONGRATULATIONS);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
